import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  footerSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 35,
    paddingLeft: 35,
    "& .footerSectionStatus": {
      display: "none",
      "@media (min-width: 1024px)": {
        display: "block",
      },
    },
    "& > div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      "& > span": {
        color: "#344054",
        font: "400 12px/16px Manrope",
        letterSpacing: "0.1em",
        marginBottom: 7,
        "@media (min-width: 1024px)": {
          marginBottom: 0,
          marginRight: 6,
        },
      },
      "& > img": {
        width: 90,
        "@media (min-width: 1024px)": {
          width: 160,
        },
      },
      "@media (min-width: 1024px)": {
        flexDirection: "row",
      },
    },
    "@media (min-width: 1024px)": {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
  shipeeziLink: {
    cursor: "pointer",
  },
}));

export default styles;
